<template>
  <div class="top-bar">
    <nav class="navbar navbar-pacific navbar-mp megamenu navbar-fixed-top">
      <div class="container-fluid">
        <div class="navbar-header">
          <router-link :to="{ path: '/' }">
            <img style="width: 68px; margin-top: 4px;" class="img-responsive hidden-xs"
              src="/static/img/logo/haitipay.png"
            />
          </router-link>

          <button
            type="button"
            class="navbar-toggle"
            v-bind:class="{hideOnMobile: loggedIn}"
            style="float:left"
            data-toggle="collapse"
            data-target=".navbar-main-collapse"
          >
            <i class="fa fa-fw fa-bars"></i>
          </button>
        </div>

        <div class="shopping-cart pull-right" id="cart">
          <!-- <a href="javascript:void(0)" v-on:click="togglePopover"> -->
          <router-link
            to="/checkout"
            style="border-bottom: 0px solid #ffffff; margin-right: 8em;"
          >
            <span class="fa fa-fw fa-shopping-cart fa-2x" aria-hidden="true"></span>
            <span id="badge" class="badge" v-if="cartItems > 0">{{ cartItems }}</span>
          </router-link>
        </div>

        <div class="navbar-collapse collapse navbar-main-collapse">
          <ul class="nav navbar-nav">
            <li v-if="!loggedIn">
              <router-link :to="{ path: '/login' }" class="color-light">Login</router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div class="toggle-sidebar" v-if="loggedIn">
      <a id="toggle-sidebar" class="hidden-md hidden-lg" href="javascript:void(0)">
        <i class="fa fa-fw fa-bars" aria-hidden="true"></i>
      </a>
    </div>
    <!-- <cart-popover :maxItems="maxCartItems"></cart-popover> -->
    <div
      v-if="loggedIn"
      class="user"
      style="z-index:900000000; margin-right: 0.4em"
    >
      <div class="dropdown user-image">
        <a id="toggle-user-menu" data-target="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <img :src="avatarUrl" width="50" height="50" />
        </a>
      <ul id="user-menu" class="dropdown-menu nv-dropdown" aria-labelledby="toggle-user-menu">
        <li>
          <router-link to="/account">
            <i class="fa fa-fw fa-user" aria-hidden="true"></i> My Account
          </router-link>
        </li>
        <li>
          <router-link to="/account/edit">
            <i class="fa fa-fw fa-pencil" aria-hidden="true"></i> Edit Profile
          </router-link>
        </li>
        <li>
          <a v-on:click.prevent="logout">
            <i class="fa fa-fw fa-sign-out" aria-hidden="true"></i> Log Out
          </a>
        </li>
      </ul>
    </div>
  </div>
  </div>
</template>

<script>
// import CartPopover from './CartPopover'
import {count, service, MAX_CART_ITEMS} from '../services/shopping-cart'
import {accountService} from '../services/account-services'
import {SHOPPING_CART_UPDATED, AVATAR_IMG_UPDATED, LOGIN_SUCCESSFUL} from '../events'

export default {
  name: 'navbar',
  // components: {CartPopover},
  data() {
    return {
      loggedIn: false,
      cartItems: count(),
      currency: 'HTG',
      maxCartItems: MAX_CART_ITEMS,
      marginleft: -900,
      toggle: false,
      avatarUrl: null
    }
  },
  beforeMount() {
    let authToken = localStorage.getItem('authToken')
    let avatarUrl = localStorage.getItem('avatarUrl')
    let defaultAvatarUrl = '/static/img/default_avatar.png'

    if (authToken) this.loggedIn = true

    if (!avatarUrl || !avatarUrl.length) {
      this.avatarUrl = defaultAvatarUrl
    } else {
      this.avatarUrl = avatarUrl
    }
  },
  mounted() {
    service.$on(SHOPPING_CART_UPDATED, () => {
      this.cartItems = count()
    })
    accountService.$on(LOGIN_SUCCESSFUL, (avatarUrl) => {
      let defaultAvatarUrl = '/static/img/default_avatar.png'
      if (!avatarUrl) avatarUrl = defaultAvatarUrl
      this.loggedIn = true
      this.avatarUrl = avatarUrl
    })
    accountService.$on(AVATAR_IMG_UPDATED, () => {
      let avatar = localStorage.getItem('avatarUrl')
      this.avatarUrl = avatar
    })
  },
  methods: {
    togglePopover: () => {
      // window.$('.cart-popover').toggleClass('hidden')
    },
    logout: () => {
      localStorage.removeItem('authToken')
      localStorage.removeItem('userId')
      localStorage.removeItem('ttl')
      localStorage.removeItem('avatarUrl')
      location.reload()
    }
  },
  props: []
}
</script>
<style scoped>
.router-link-active {
  font-weight: bold;
  border-bottom: 1px solid #ffffff;
  opacity: 1;
}
a {
  cursor: pointer;
}
.hideOnMobile {
  margin-left: -900px;
}
.top-bar .user-image {
  cursor: pointer;
}
.top-bar .user ul.nv-dropdown li a {
  color: white;
  display: block;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 5px;
  padding-bottom: 5px;
  text-transform: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue